module.exports = __webpack_public_path__ + "img/9.caf21835.jpg";